export enum MainSettingsEnum {
  LocalLabel = 'localLabel',
  CountyLabel = 'countyLabel',
  SameAdress = 'sameAddress',
  AssSelectorType = 'assSelectorType',
  ShowMyAssociation = 'showMyAssociation',
  ShowMyDistrict = 'showMyDistrict',
  UseDigitalMembercard = 'useDigitalMembercard',
  Currency = 'currency',
  MemberGridCustomCols = 'memberGridCustomCols',
  MemberGridHideDistrict = 'memberGridHideDistrict',
  MemberGridHideAssociation = 'memberGridHideAssociation',
  OtherLabelPlural = 'otherLabelPlural',
  OtherLabel = 'otherLabel',
}
